<template lang="pug">
  footer.footer
    .container.is-fluid
      .content
        h3.title.mb-5 We're working on many projects, all language-related. Don't miss anything 🙂
        .columns
          .column.is-offset-2-desktop.is-6-tablet.is-4-desktop
            h4.title.has-text-centered
              img.img-flag.mr-2(src="/static/flags/en-US.png")
              img.img-flag(src="/static/flags/en-GB.png")
            a.box.is-flex.vcenter(href="https://americanipachart.com/?pid=fl" target="_blank")
              b-icon.c-aipa(icon="image" size="is-large")
              span
                span.is-flex.vcenter.c-aipa AmericanIPAchart.com
                em Learn to pronounce American English sounds
            a.box.is-flex.vcenter(href="https://teachertool.io/?pid=fl" target="_blank")
              img.img-logo(src="https://teachee.io/logo_teachertool_v2_square.png")
              span
                span.is-flex.vcenter.mt-1.c-tt Teachee.io
                em Teach language online
          .column.is-6-tablet.is-4-desktop
            h4.title.has-text-centered
              img.img-flag.mr-2(src="/static/flags/fr-FR.png")
            a.box.is-flex.vcenter(href="https://bilingueanglais.com/?pid=fl" target="_blank")
              b-icon.c-ba(icon="rss-feed" size="is-large")
              span
                span.is-flex.vcenter.c-ba BilingueAnglais.com
                em Comment bien apprendre l'anglais et devenir bilingue

            a.box.is-flex.vcenter(href="https://bilingueanglais.com/decouvrez-clicknspeak/?pid=fl" target="_blank")
              b-icon.c-cs(icon="comment" size="is-large")
              span
                span.is-flex.vcenter.c-cs Click & Speak™ English
                em Comment bien apprendre l'anglais et devenir bilingue

</template>

<script>

export default {
  name: "PartnerFooter",
  components: {
  },
  data() {
    return {};
  },
  created() {
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
  @import 'colors';

  .img-flag {
    max-width: 30px;
  }
  .img-logo {
    max-width: 37px;
    border-radius: 3px;
    margin-right: 11px;
    margin-left: 6px;
  }
  .footer  {
    a {
      /*font-size: 1.2rem;*/
    }
    em {
      font-style: normal;
      color: $darkGray;
      font-size: 0.8rem;
    }
    .box {
      span+span,
      img+span {
        line-height: 1.3rem;
        text-align: left;
        word-break: break-word;
      }
    }
    span[class*="c-"] {
      text-transform: uppercase;
      font-weight: 700;
      letter-spacing: 1px;
    }
    .c-tt { color: #FF5B62 }
    .c-mm { color: #42d390 }
    .c-fl { color: #42d390 }
    .c-ba { color: #153D7A }
    .c-cs { color: #3498db }
    .c-aipa { color: #ffc107 }
    .c-aipa { color: #f1c40f }
  }
  @media screen and (max-width: 425px) {
    .footer  em {
      font-size: 0.7rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PartnerFooter.vue